"use client";

import LoadingLogo from "./Logo";

export default function LoadingStart() {
  return (
    <div className="h-screen w-full flex items-center justify-center">
      <LoadingLogo />
    </div>
  );
}
